module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.currentTerminateMode) ? _c('div', {
    staticClass: "bg-blue-grey-100 p-30"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Do you want to Terminate " + _vm._s(_vm.team.name) + " Team?")]), _vm._v(" "), _c('p', [_vm._v("After Terminated, " + _vm._s(_vm.team.name) + " Team will not be able to access ByteArk Account and use any service.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-outline",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit(true)
      }
    }
  }, [_vm._v("\n      Terminate team"), _c('span', {
    staticClass: "glyphicon"
  })])]) : _c('div', {
    staticClass: "bg-red-600 p-30"
  }, [_c('h5', {
    staticClass: "title white"
  }, [_vm._v(_vm._s(_vm.team.name) + " is currently Terminated , Do you want to Activate " + _vm._s(_vm.team.name) + " Team?")]), _vm._v(" "), _c('p', {
    staticClass: "white"
  }, [_vm._v("After Activated, " + _vm._s(_vm.team.name) + " Team will be able to access ByteArk Account and use any service.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default white btn-outline",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit(false)
      }
    }
  }, [_vm._v("\n      Activate team"), _c('span', {
    staticClass: "glyphicon"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-421cb8a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teams/TeamTerminate.vue
// module id = 526
// module chunks = 1